import React from 'react';
import createClient from "./apollo/client";
import { ApolloProvider } from "@apollo/client";
import Search from './components/pages/search';
import styles from "./App.module.scss";

const App:React.FC = () =>{

  const client = createClient();

  return (
    <div className={styles.csTeamSearchPage}>
      <div className={styles.csTeamSearchContent}>
        <ApolloProvider client={client}>
          <Search />
        </ApolloProvider>
      </div>
    </div>
  );
}

export default App;
